export const CHAT_DISPLAY_NAME_MAX_LENGTH = 60;

export function resolveGroupChatTitle({ displayName, storedName } = {}) {
  const custom = String(displayName || "").trim();
  if (custom) {
    return custom;
  }
  const stored = String(storedName || "").trim();
  return stored || "Organization chat";
}

export function shouldOpenOrgThread(value) {
  return value === true;
}

function browserStorage() {
  if (typeof window === "undefined") {
    return null;
  }
  return window.localStorage;
}

export function readStoredChatPreferences(storage) {
  const store = storage || browserStorage();
  try {
    const raw = store?.getItem?.("appSettings");
    if (!raw) {
      return null;
    }
    const settings = JSON.parse(raw);
    const hasName = Object.prototype.hasOwnProperty.call(
      settings,
      "chatDisplayName",
    );
    const hasOpen = Object.prototype.hasOwnProperty.call(
      settings,
      "chatOpensOnOrgThread",
    );
    if (!hasName && !hasOpen) {
      return null;
    }
    return {
      chatDisplayName: hasName ? settings.chatDisplayName : undefined,
      chatOpensOnOrgThread: hasOpen
        ? settings.chatOpensOnOrgThread
        : undefined,
    };
  } catch (error) {
    return null;
  }
}

export function activeChatPreferences(sessionChannel, storage) {
  const stored = readStoredChatPreferences(storage);
  const displayName =
    stored && stored.chatDisplayName !== undefined
      ? stored.chatDisplayName || ""
      : sessionChannel?.displayName || "";
  const opensOnOrgThread =
    stored && stored.chatOpensOnOrgThread !== undefined
      ? shouldOpenOrgThread(stored.chatOpensOnOrgThread)
      : shouldOpenOrgThread(sessionChannel?.opensOnOrgThread);

  return {
    displayName,
    opensOnOrgThread,
    title: resolveGroupChatTitle({
      displayName,
      storedName: sessionChannel?.name,
    }),
  };
}
